import React from "react";
import { useEffect } from "react";
import AkunSaya from "../../components/Pinjam/Akun";

const Akun = () => {
  useEffect(() => {
    document.title = "Akun";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <AkunSaya/>
    </div>
  );
};

export default Akun;
